import React from 'react';
import { Button } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useWebViewDetection } from '../Hooks/useWebViewDetection';

/**
 * Banner component that detects in-app browsers and prompts users to open in external browser
 * This solves OAuth2 login issues in webviews (LinkedIn, Facebook, etc.)
 */
const WebViewBanner: React.FC = () => {
    const { isWebView, platformName } = useWebViewDetection();
    const [dismissed, setDismissed] = React.useState(false);

    // Don't show banner if not in webview or if dismissed
    if (!isWebView || dismissed) {
        return null;
    }

    /* Uncomment if you want to re-enable the "Open in Browser" button
    const handleOpenInBrowser = () => {
        // Try to open in default browser
        // On most mobile devices, this will open the system browser
        const currentUrl = window.location.href;

        // For iOS, we can use a special intent
        if (/iPhone|iPad/i.test(navigator.userAgent)) {
            // iOS will show "Open in Safari" option
            window.location.href = currentUrl;
        } else {
            // Android and others
            window.open(currentUrl, '_system');
        }
    };
    */

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: '12px 16px',
            background: '#fff3cd',
            borderBottom: '2px solid #ffc107',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                flexWrap: 'wrap'
            }}>
                <WarningOutlined style={{
                    fontSize: '20px',
                    color: '#f57c00',
                    flexShrink: 0
                }} />
                <div style={{ flex: 1, minWidth: '200px' }}>
                    <div style={{
                        fontWeight: 600,
                        color: '#333',
                        marginBottom: '4px',
                        fontSize: '14px'
                    }}>
                        Login non disponibile in {platformName}
                    </div>
                    <div style={{
                        fontSize: '13px',
                        color: '#666',
                        lineHeight: '1.4'
                    }}>
                        Per motivi di sicurezza, il login con Google non funziona nei browser integrati nelle app social.<br/>
                        Apri il sito nel browser dal menu di questa finestra dell'app.
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                    flexShrink: 0
                }}>
                    {/*<Button
                        type="primary"
                        icon={<ExportOutlined />}
                        onClick={handleOpenInBrowser}
                        style={{
                            background: '#f57c00',
                            borderColor: '#ef6c00',
                            fontWeight: 600,
                            height: '36px'
                        }}
                    >
                        Apri nel Browser
                    </Button>*/}
                    <Button
                        type="text"
                        onClick={() => setDismissed(true)}
                        style={{
                            color: '#666',
                            height: '36px'
                        }}
                    >
                        ✕
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default WebViewBanner;
